
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRightCircle } from 'lucide-react';

interface ConfirmPaymentButtonProps {
  confirmPayment: () => Promise<void>;
  pulsing: boolean;
  disabled?: boolean;
}

const ConfirmPaymentButton: React.FC<ConfirmPaymentButtonProps> = ({ confirmPayment, pulsing, disabled = false }) => {
  return (
    <motion.div
      className="w-full"
      whileHover={{ scale: disabled ? 1 : 1.02 }}
      whileTap={{ scale: disabled ? 1 : 0.98 }}
      animate={pulsing && !disabled ? { scale: [1, 1.05, 1] } : {}}
      transition={{ duration: 0.5 }}
    >
      {/* Attention-grabbing callout */}
      <div className="absolute -top-12 right-0 bg-blue-100 text-blue-800 px-3 py-1.5 rounded-lg flex items-center gap-1.5 text-sm font-medium shadow-sm border border-blue-200 transform -rotate-2">
        <ArrowRightCircle size={16} className="animate-bounce" />
        <span>Nhớ bấm nút xác nhận!</span>
      </div>
      
      <Button 
        className={`w-full h-14 text-lg font-medium ${disabled 
          ? 'bg-gray-400 hover:bg-gray-500 border-2 border-gray-400 hover:border-gray-500 cursor-not-allowed opacity-80' 
          : 'bg-green-600 hover:bg-green-700 border-2 border-green-500 hover:border-green-600'}`}
        onClick={confirmPayment}
        size="lg"
        disabled={disabled}
      >
        <span className="flex items-center gap-2">
          <ArrowRightCircle className="h-5 w-5" />
          Xác nhận đã chuyển khoản
        </span>
      </Button>
      
      {disabled && (
        <p className="text-center text-red-500 text-sm mt-2">
          Vui lòng đánh dấu vào ô "Tôi đã chuyển khoản" để tiếp tục
        </p>
      )}
    </motion.div>
  );
};

export default ConfirmPaymentButton;
